import React from 'react'

import Navbar from '../Components/Navbar'
import TubeDetails from '../Components/TubesDetails'
import Footer from '../Components/Footer'

const SeamlessTubes = () => {
  return (
    <div>
      <Navbar />
      <TubeDetails />
      <Footer />
    </div>
  )
}

export default SeamlessTubes